import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAutoAnimate } from "@formkit/auto-animate/react";

//import general components
import BaseTitle from "../../components/common/base-title/base-title";
import Footer from "../../components/common/footer/footer";
import ExploreIranList from "../../components/view/country-tour/country-tour-list";

export default function CountryTour() {
    //general variables
    const { t } = useTranslation();
    const [parent] = useAutoAnimate();

    return (
        <Grid className="tour" container item xs={12} mb={5}>
            <Grid
                className="tour__background"
                container
                item
                xs={12}
                rowGap={2}
                alignItems={{ xs: "center", md: "flex-end" }}
                ref={parent}
                sx={{ height: "fit-content" }}
            >
                <Grid container item xs={12} direction="column" justifyContent="center" alignItems="center" height={200} px={{ xs: 2, md: 0 }}>
                    <h1 className="tour__title">{t("tourTitle")}</h1>
                    <span className="tour__sub-title">{t("tourTitle2")}</span>
                </Grid>
            </Grid>

            <Container maxWidth="lg">
                <Grid container item xs={12} rowGap={{ xs: 2, md: 5 }} mb={15}>
                    <Grid container item xs={12} justifyContent="space-between" mt={5}>
                        <BaseTitle title={t("tourList")} />
                    </Grid>

                    <Grid container item xs={12} justifyContent="space-between" alignItems="flex-start">
                        <ExploreIranList />
                    </Grid>
                </Grid>
            </Container>
            <Footer />
        </Grid>
    );
}
